module.exports = __webpack_public_path__ + "static/media/dataarrowright.4b264a5f.svg";